import React, { createContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RouteContants from "../../constants/routesContent.json";
import {
  getReAssignRole,
  deleteAssignRoleApi,
  visitorMagneticCardApi,
  visitorCardExcel,
} from "../../api/Api";

export const SettingsRoleContext = createContext({});

export const SettingsRoleContextProvider = ({ children }) => {
  const [roleDetails, setRoleDetails] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [roleAssignId, setRoleAssignId] = useState();
  const [mainRole, setMainRole] = useState("");
  const [alert, setAlert] = useState(false);
  const [empIdSet, setEmpIdSet] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();
  const [statusCode, setStatusCode] = useState(0);

  const [cardExcel, setCardExcel] = useState(null);
  const [fileErrorMessage, setFileErrorMessage] = useState("");
  const [cardFile, setCardFile] = useState(null);
  const [cardFileDownload, setCardFileDownload] = useState();
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const location = useLocation();
  const roleDetailByState = location?.state;

  const navigateToRoleManagement = () => {
    navigate(RouteContants.SETTINGS_ROLE_MANAGEMENT);
  };
  const navigateToSettings = () => {
    navigate(RouteContants.SETTINGS);
  };
  const navigateToPermissions = () => {
    navigate(RouteContants.SETTINGS_PERMISSION);
  };
  const navigateToRoleList = () => {
    navigate(RouteContants.SETTINGS_ROLE);
  };

  const getReassignList = async () => {
    const roleId = location?.state?.RoleId;
    try {
      const response = await getReAssignRole(roleId);
      if (response?.data?.status === 200) {
        setRoleDetails(response?.data?.data?.admins);
      }
    } catch (error) {
      if (
        error.response.data.status === 401 ||
        error.response.data.status === 400
      ) {
        setAlert(true);
        setResponseMessage(error.response.data.message);
      } else if (error.response.data.status === 403) {
        setAlert(true);
        setResponseMessage(error.response.data.message);
      } else {
        setAlert(true);
        setResponseMessage("Somethingwent wrong");
      }
    }
  };

  const deleteAssignRole = async (EmployeeId) => {
    try {
      const response = await deleteAssignRoleApi(EmployeeId);
      if (response?.data?.status === 200) {
        setAlert(true);
        setResponseMessage(response?.data?.message);
      }
    } catch (error) {
      if (
        error.response.data.status === 400 ||
        error.response.data.status === 401
      ) {
        setResponseMessage(error.response.data.message);
        setAlert(true);
      } else {
        setResponseMessage("Somthing went wrong");
        setAlert(true);
      }
    }
  };

  const assignRole = (roleId, roleName, isEdit, EmployeeDetail) => {
    navigate(RouteContants.ROLE_ASSIGN, {
      state: { roleId, roleName, isEdit, EmployeeDetail },
    });
  };

  // file upload validation
  const handleCardValidation = (value) => {
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    if (!value) {
      setFileErrorMessage("Upload .xlsx file");
      return false;
    } else if (!allowedTypes.includes(value.type)) {
      setFileErrorMessage("Please upload .xlsx file");
      return false;
    }
    // else if (value.size > maxSizeInBytes) {
    //   setImageErrorMessage(pageContent.imageSizeValidationMessage);
    //   return false;
    // }
    else {
      setFileErrorMessage("");
      return true;
    }
  };

  const handleAlertSubmit = () => {
    setAlert(false);
  };

  const handleMagneticUpload = (event) => {
    setCardFile(event?.target?.files[0]);
    setCardExcel(event?.target?.files[0]?.name);
  };
  const editvistorData = () => {
    let formData = new FormData();
    formData.append("visitorCard", cardFile);

    return formData;
  };

  const visitorCardSubmit = async (e) => {
    e.preventDefault();
    const cardData = {
      visitorCard: cardFile,
    };
    const fileData = handleCardValidation(cardFile);
    if (fileData) {
      setSpinnerStatus(true);
      try {
        const file = await visitorMagneticCardApi(editvistorData(), cardData);
        if (file?.data?.status === 200) {
          setAlert(true);
          setSpinnerStatus(false);
          setResponseMessage(file?.data?.message);
          setCardExcel(null);
          setCardFile(null);
        }
      } catch (error) {
        setSpinnerStatus(false);
        setStatusCode(error?.response?.data?.status);
        if (
          error?.response?.data?.status === 401 ||
          error?.response?.data?.status === 400 ||
          error?.response?.data?.status === 403
        ) {
          const errorMessage = error?.response?.data?.message;
          setAlert(true);
          setResponseMessage(errorMessage);
        } else {
          setAlert(true);
          setResponseMessage("Something went wrong");
        }
      }
    }
  };

  const callGetVisitorCardExcel = async () => {
    try {
      const getExcel = await visitorCardExcel();
      if (getExcel.status === 200) {
        setCardFileDownload(getExcel.data.data.filename);
      }
      console.log(getExcel);
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 401 ||
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 403
      ) {
        const errorMessage = error?.response?.data?.message;
        setAlert(true);
        setResponseMessage(errorMessage);
      } else {
        setAlert(true);
        setResponseMessage("Something went wrong");
      }
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContants.LOGIN);
  };

  useEffect(() => {
    callGetVisitorCardExcel();
  }, []);
  const providerValue = {
    navigateToPermissions,
    navigateToSettings,
    mainRole,
    goBack,
    roleDetailByState,
    getReassignList,
    spinnerStatus,
    setIsEdit,
    deleteAssignRole,
    setAlert,
    responseMessage,
    navigateToRoleList,
    alert,
    roleDetails,
    navigateToRoleManagement,
    assignRole,
    statusCode,
    logout,
    handleMagneticUpload,
    setFileErrorMessage,
    fileErrorMessage,
    visitorCardSubmit,
    cardExcel,
    handleAlertSubmit,
    cardFileDownload,
  };
  return (
    <SettingsRoleContext.Provider value={providerValue}>
      {children}
    </SettingsRoleContext.Provider>
  );
};
